import { css } from '@emotion/css'
import { breakpoint, mediaQueryHelper } from '@offerzen/pinata-shame'

import { navbarHeight } from '../../compounds/Navbar'

const styles = {
  wrapper: css({
    paddingTop: navbarHeight,

    [mediaQueryHelper(breakpoint.tablet)]: {
      padding: 0,
    },
  }),
}

export default styles
